var _path, _path2, _path3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDieselplusLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 16,
    viewBox: "0 0 145 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_ANYSUPPLY292)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.003 0.357422V2.98291H137.438V4.95229H140.003V7.57778H141.927V4.95229H144.491V2.98291H141.927V0.357422H140.003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4469 12.8392H9.56404C11.0393 12.8392 11.6134 12.4095 11.6134 10.7717V9.21424C11.6134 7.57648 11.0393 7.14669 9.56404 7.14669H3.4469V12.8392ZM0 4.28418H10.4028C13.8493 4.28418 15.0603 5.44575 15.0603 8.29113V11.7894C15.0603 14.6348 13.8493 15.796 10.4028 15.796H0V4.28418Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31_ANYSUPPLY292",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 145,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9229H144.492V0.357422H0V15.9229Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31_ANYSUPPLY292)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3367 15.797H20.7839V4.28516H17.3367V15.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.302 4.28516H35.5994V6.95741H26.7489V8.80078H35.1333V11.1853H26.7489V13.0305H35.8008V15.797H23.302V4.28516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.688 12.0282H41.1349C41.1502 13.253 41.6316 13.3487 42.6255 13.3487H46.8487C47.5783 13.3487 48.3236 13.2687 48.3236 12.3791C48.3236 11.3771 47.9203 11.3136 43.4795 11.3136C38.2935 11.3136 37.703 10.6768 37.703 7.84674C37.703 5.76491 37.8895 4.1582 42.2375 4.1582H47.0502C51.0252 4.1582 51.3982 5.54216 51.3982 7.56045V7.92705H47.9509C47.9509 7.08426 47.8575 6.73443 46.2742 6.73443H42.4547C41.678 6.73443 41.1502 7.00394 41.1502 7.62399C41.1502 8.62599 41.5692 8.65848 45.2647 8.6417C50.6212 8.62599 51.8636 8.96012 51.8636 12.3145C51.8636 15.4148 50.8387 15.9238 46.2582 15.9238H42.0817C38.945 15.9238 37.688 15.3205 37.688 12.8232V12.0282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9993 4.28516H66.2966V6.95741H57.4462V8.80078H65.8309V11.1853H57.4462V13.0305H66.4981V15.797H53.9993V4.28516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5869 4.28516H72.0338V12.8402H79.7817V15.797H68.5869V4.28516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5203 7.25807C92.5203 5.89089 91.7903 5.55712 90.4706 5.55712H83.0954V9.99243H90.595C91.806 9.99243 92.5203 9.54729 92.5203 8.35467V7.25807ZM81.5741 4.28418H90.8275C92.8773 4.28418 94.0419 4.72967 94.0419 7.41727C94.0419 9.97708 93.8397 11.265 90.533 11.265H83.0954V15.796H81.5741V4.28418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1608 4.28516H97.6828V14.5255H106.409V15.797H96.1608V4.28516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.046 4.28516H109.568V12.888C109.568 14 109.94 14.6525 112.006 14.6525H117.284C119.35 14.6525 119.723 14 119.723 12.888V4.28516H121.243V12.9038C121.243 15.2401 120.094 15.9237 117.237 15.9237H112.052C109.195 15.9237 108.046 15.2401 108.046 12.9038V4.28516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.954 12.1717H125.383V12.9824C125.383 14.1115 125.973 14.6523 127.867 14.6523H132.587C134.791 14.6523 135.444 14.1747 135.444 12.5212C135.444 11.0741 134.885 10.7089 132.991 10.7089H130.102C125.46 10.7089 123.939 10.423 123.939 7.37019C123.939 4.7472 125.46 4.1582 128.596 4.1582H131.872C135.646 4.1582 136.593 5.1445 136.593 7.19527V7.59294H135.164C135.132 5.76491 134.947 5.43079 130.957 5.43079H129.342C126.407 5.43079 125.368 5.58893 125.368 7.48156C125.368 8.84839 125.786 9.30923 128.162 9.30923H132.665C135.63 9.30923 136.872 10.1849 136.872 12.1396V12.8878C136.872 15.7178 134.606 15.9238 132.354 15.9238H128.131C125.91 15.9238 123.954 15.5262 123.954 13.0145V12.1717Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_ANYSUPPLY292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.667,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDieselplusLogoWhite);
export default __webpack_public_path__ + "static/media/dieselplus-logo-white.3b366b28efcb5f05f351dd3223487a29.svg";
export { ForwardRef as ReactComponent };